import loadable from '@loadable/component';

export const OrgDashboardViewVolopPageLoadable = loadable(
  () => import('./OrgDashboardViewVolopPage'),
  {
    resolveComponent: (module) => module.OrgDashboardViewVolopPage,
    ssr: false,
  },
);
